module.exports = __webpack_public_path__ + "img/4.3fd3737b.jpg";